export default class Cnpj {
	constructor() {
		this.id =  null;
		this.numero =  '';
		this.razaoSocial =  '';
		this.telefone1 =  '';
		this.telefone2 =  '';		
		this.celular = '';
		this.dataCadastro =  null;
		this.principal =  false;
		this.codigoContabil =  '';
		this.codigoFilial = '';
		this.tipoNumeroDocumento = 'cnpj';
	}    
}